export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://djangoapi-g2bra7cscggqdkg5.centralus-01.azurewebsites.net/api';
export const API_USERNAME = process.env.REACT_APP_API_USERNAME;
export const API_PASSWORD = process.env.REACT_APP_API_PASSWORD;

console.log('API Base URL:', BASE_URL);
console.log('API Username available:', !!API_USERNAME);
console.log('API Password available:', !!API_PASSWORD);